const amountOfParticipantsOnPage = 6;

export default amountOfParticipantsOnPage;
